import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from "prop-types";

import ModalContentWrapper from "./ModalContentWrapper";

import './ModalUploadDocument.scss' ;
import { useForm } from "react-hook-form";
import DropdownSchoolGroups from "root/ReactHookForm/ui/DropdownSchoolGroups";
import { createNewProvider, getProviderDetails, updateProviderDetails } from "root/DataFunctions/ProviderFns";
import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { AddSchoolModalMode } from "root/Modals/useModalAddSchool";

const ErrorDiv = ( props ) =>
{
    const style = { marginTop: '5px', color: 'red' };

    return <div style={ style }>{ props.children }</div>
}

const ModalAddSchool = ( {  onSaveCompleted, onClose, provider_id, params, mode } ) =>
{
    const [ data, setData ] = useState ( { loading: true, data: [] } );
    const [ buttonState, setButtonDisabled ] = useState (false) ;

    const allowEntryOfEstablishmentNumber = mode === AddSchoolModalMode.CREATE ;

    const { register, control, handleSubmit, setFocus, setValue, watch, formState: { errors: formErrors } } = useForm (
        {
            defaultValues: {
                school: {
                    provider_name: '',
                    establishment_number: '',
                    postcode: '',
                    address1: '',
                    address2: '',
                    county: '',
                    town: '',
                    school_group: null
                }
            }
        } );

    const primaryButtonStyle = {
        marginRight: '0px',
        marginLeft: '10px'
    };

    useEffect ( () =>
    {
        if ( mode === AddSchoolModalMode.EDIT )
        {
            getData ();
        }
        else
        {
            setData( { loading: false, data: [] }) ;
        }
    }, [] );

    const getData = () =>
    {
        getProviderDetails ( 'current',  provider_id, ( response ) =>
        {
            const returnData = getDataFromResponse ( response );

            const school = returnData[0] ;

            // Set the form values to the new values loaded from the database
            setValue ( 'school', {
                provider_name: school.provider_name,
                town: school.town,
                address1: school.address1,
                address2: school.address2,
                address4: school.address4,
                postcode: school.postcode,
                establishment_number: school.establishment_number,
                school_group: { value: school.provider_group_id, label: school.group_name }
            }) ;

            setData ( { loading: false, data: returnData } )
        } )
    }

    useEffect ( () =>
    {
        if ( data.loading === false )
        {
            setFocus ( "school.provider_name" );
        }
    }, [ data.loading ] );

    const doUpdateSchool = ( data, onComplete ) =>
    {
        setButtonDisabled ( true );

        updateProviderDetails( provider_id, data, ( response ) =>
        {
            setButtonDisabled ( false );

            if ( onComplete !== null )
            {
                onSaveCompleted ( response );
            }
        } )
    }

    const doCreateSchool = ( data, onComplete ) =>
    {
        setButtonDisabled ( true );

        createNewProvider( data, ( response ) =>
        {
            setButtonDisabled ( false );

            if ( onComplete !== null )
            {
                onSaveCompleted ( response );
            }
        } )
    }

    const onClickGenerate = () =>
    {
        handleSubmit ( onSubmit ) ();
    }

    const onClickCancel = () =>
    {
        onClose ();
    }

    const onSubmit = ( data ) =>
    {
        if ( mode === AddSchoolModalMode.EDIT )
        {
            doUpdateSchool ( data ) ;
        }
        else if ( mode === AddSchoolModalMode.CREATE )
        {
            doCreateSchool ( data ) ;
        }
    }

    /* const validateDropdown = ( val ) =>
    {
        if ( val.value === 0 )
        {
            return "You must select a group";
        }
    } */

    const validateEmail = ( val ) =>
    {
        if ( val !== '' && !String(val)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            ))
        {
            return "You must enter a valid email address";
        }
    }

    const formContent = () =>
    {
        return (
            <Fragment>
                <div className='buy-card-right'>
                    <p>Complete the fields below and click SAVE to create a new school.</p>

                    { data.loading === false && <form className='registration-form' onSubmit={ handleSubmit ( onSubmit ) }>

                        <label>Group</label>
                        <DropdownSchoolGroups readOnly={ false } control={ control } name='school.school_group' rules={{ required: false }} placeholder='Please select a group' isClearable={true} isSearchable={ true }/>
                        { formErrors.school?.school_group && <ErrorDiv>{ formErrors.school.school_group.message }</ErrorDiv> }

                        <div className='row'>
                            <div className='col-md-6'>
                                <label>School Name</label>
                                <input className='form-control' { ...register ( "school.provider_name", { required: true } ) } />
                                { formErrors.school?.provider_name && <ErrorDiv>Please enter the school name</ErrorDiv> }
                            </div>
                            <div className='col-md-6'>
                                <label>School ID</label>
                                <input readOnly={!allowEntryOfEstablishmentNumber} className='form-control' { ...register ( "school.establishment_number", { required: true } ) } />
                                { formErrors.school?.establishment_number && <ErrorDiv>Please enter the local authority id </ErrorDiv> }
                            </div>

                        </div>

                        <div className='row'>
                            <div className='col-md-6'>
                                <label>Street</label>
                                <input className='form-control' { ...register ( "school.address1", { required: false } ) } />
                                { formErrors.school?.address1 && <ErrorDiv>Please enter the first line of address</ErrorDiv> }
                            </div>
                            <div className='col-md-6'>
                                <label>Locality (optional)</label>
                                <input className='form-control' { ...register ( "school.address2", { required: false } ) } />
                                { formErrors.school?.address2 && <ErrorDiv>Please enter second line of address</ErrorDiv> }
                            </div>
                            <div className='col-md-6'>
                                <label>Town or city</label>
                                <input className='form-control' { ...register ( "school.town", { required: false } ) } />
                                { formErrors.school?.town && <ErrorDiv>Please enter a town or city</ErrorDiv> }
                            </div>
                            <div className='col-md-6'>
                                <label>County (optional)</label>
                                <input className='form-control' { ...register ( "school.address4", { required: false } ) } />
                                { formErrors.school?.address4 && <ErrorDiv>Please enter a county</ErrorDiv> }
                            </div>
                            <div className='col-md-6'>
                                <label>Postcode</label>
                                <input className='form-control' { ...register ( "school.postcode", { required: false } ) } />
                                { formErrors.school?.postcode && <ErrorDiv>Please enter a postcode</ErrorDiv> }
                            </div>
                        </div>

                        <div className='modal-button-row'>
                            <button type="button" onClick={ onClickCancel } className="btn btn-icon btn-secondary btn-icon-right btn-small">Cancel<i className="et-arrow-bold-left"/></button>
                            <button disabled={buttonState} type="button" onClick={ onClickGenerate } style={ primaryButtonStyle } className="btn btn-icon btn-red btn-primary btn-icon-right btn-small">Save<i className="et-check"/></button>
                        </div>
                    </form> }
                </div>
            </Fragment>
        )
    }

    const getTitle = () =>
    {
        switch ( mode )
        {
            case AddSchoolModalMode.EDIT:
                return 'Edit Establishment Details'
            case AddSchoolModalMode.CREATE:
                return 'Create Establishment'
        }
    }

    return (
        <ModalContentWrapper className="modal-wrapper">
            <h3>{ getTitle() }</h3>
            <div className='buy-card'>
                <div>
                    <span className='glyphicon glyphicon-file' style={ { color: 'var(--vschool-mild-blue)', fontSize: '15rem', marginTop: '30px' } }/>
                </div>
                { formContent () }
            </div>
        </ModalContentWrapper>
    )
}

export default ModalAddSchool;

ModalAddSchool.propTypes = {
    params: PropTypes.object,
    mode: PropTypes.oneOf ( ['edit', 'create']),
    user_id: PropTypes.string,
};
